import { LifeBuoy } from "lucide-react";
import { HELPLINE_NOTE } from "../data/content";

export default function CrisisStrip() {
  return (
    <div
      data-testid="crisis-banner"
      className="relative z-[60] flex flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-pinedeep px-4 py-2 text-center"
    >
      <LifeBuoy className="h-3.5 w-3.5 text-terra" aria-hidden="true" />
      <p className="max-w-3xl text-[11px] leading-snug text-cream/85 sm:text-xs">
        {HELPLINE_NOTE}{" "}
        <a
          data-testid="crisis-banner-helpline-link"
          href="https://findahelpline.com"
          target="_blank"
          rel="noopener noreferrer"
          className="font-semibold text-blush underline underline-offset-2 hover:text-white"
        >
          Find a helpline
        </a>
      </p>
    </div>
  );
}
